export function addOutgoingCall(data){
    return dispatch => {
       return dispatch({
           type: 'ADD_OUTGOING_CALL',
           payload: data
       });
    };
}

export function updateOutgoingCall(data){
    return dispatch => {
       return dispatch({
           type: 'UPDATE_OUTGOING_CALL',
           payload: data
       });
    };
}

export function removeOutgoingCall(data){
    return dispatch => {
       return dispatch({
           type: 'REMOVE_OUTGOING_CALL',
           payload: data
       });
    };
}


// WEBPACK FOOTER //
// ./src/actions/outgoingCalls.js